const fclExportFactoryChargesData = {
    colNames : {
        twoSpan: '',
        twoSpan1: 'Per Container',
        twoSpan2: '',
        perShipment: 'Per BL'
    },
    initialLength: 11,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 2,
            chargeDescription: 'applicable)',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 3,
            chargeDescription: 'Origin Charges',
            currency: 'INR'
        },
        {
            id: 4,
            chargeDescription: 'Origin Inland Haulage',
            currency: 'INR',
            disabled: ['perShipment']
        },
        {
            id: 5,
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            disabled: ['perShipment']
        },
        {
            id: 6,
            chargeDescription: 'Hazardous Surcharge',
            currency: 'USD',
            disabled: ['perShipment']
        },
        {
            id: 7,
            chargeDescription: 'Destination Inland Haulage',
            currency: ''
        },
        {
            id: 8,
            chargeDescription: 'Carrier Destination Charges',
            currency: ''
        },
        {
            id: 9,
            chargeDescription: 'Destination Terminal Charges',
            currency: ''
        },
        {
            id: 10,
            chargeDescription: 'Import Customs Clearance',
            currency: ''
        },
        {
            id: 11,
            chargeDescription: 'Door Delivery Charges',
            currency: '',
            disabled: ['perShipment']
        },{
            id: 12,
            chargeDescription: 'Terminal Handling Fees',
            currency: '',
                  disabled: ['perShipment']
        },{
            id: 13,
            chargeDescription: 'BL Fees',
            currency: '',
                  disabled: ['perShipment']
        }
    ]
}
export default fclExportFactoryChargesData